module.exports = __webpack_public_path__ + "assets/img/24.b4873965.png";